import { createSelector } from "reselect";
import get from "lodash/get";
import { userSINSelector } from "../authInfo";
import {
  selectAppSettings,
  orderRefSelector,
  sessionTokenSelector,
  orderDetailsSelector,
  genericSelector,
  userOrdersDetailsSelector
} from "ducks/selectors";

const upgradeTo5GDomain = state =>
  get(state, "form.UpgradeTo5GForm.values", {});

// ***************************************************************
// ************** upgradeTo5GForm selectors ******************
// ***************************************************************

export const upgradeTo5GSelector = createSelector(
  upgradeTo5GDomain,
  upgradeTo5G => upgradeTo5G
);

// ***************************************************************
// *************** upgradeTo5GForm makeSelect *******************
// ***************************************************************

export const makeSelectUpgradeTo5GForm = () => upgradeTo5GSelector;

export const makeSelectUpgradeTo5GPayload = () =>
  createSelector(
    upgradeTo5GSelector,
    orderRefSelector,
    sessionTokenSelector,
    orderDetailsSelector,
    userSINSelector,
    (upgradeTo5G, order_ref, session_token, orderDetails, accountNumber) => {
      const isESIM = get(upgradeTo5G, "sim_type") === "esim";
      return {
        accountNumber,
        order_ref,
        session_token,
        sim_type: isESIM ? "ESIM" : "PHYSICAL_SIM",
        primary_id: get(upgradeTo5G, "primary_id"),
        switch_to_esim: isESIM,
        skip_form_submission:
          get(orderDetails, "state") === "DELIVERY_FAILED" ||
          get(orderDetails, "in_progress"),
        inventoryType: get(upgradeTo5G, "sim_replacement_type"),
        reason: isESIM ? "switch_to_5g_esim" : "upgrade_sim",
        nric: get(upgradeTo5G, "primary_id") || get(upgradeTo5G, "nric")
      };
    }
  );

export const makeSelectUpgradeTo5GFormInitialValues = () =>
  createSelector(
    genericSelector,
    orderDetailsSelector,
    userOrdersDetailsSelector,
    (generic, orderDetails, userOrdersDetails) => {
      return {
        country_code: get(generic, "contact_number.prefix"),
        ...userOrdersDetails,
        contact_number: get(
          userOrdersDetails,
          "contact_number",
          get(orderDetails, "phone_number")
        )
      };
    }
  );

export const makeSelectSimReplacementReasons = () =>
  createSelector(
    selectAppSettings,
    upgradeTo5GSelector,
    (appSettings, upgradeTo5GForm) => {
      const replacement_sim_type = upgradeTo5GForm?.replacement_sim_type?.value;
      return (
        get(
          appSettings,
          `sim_replacement_reasons_for_sim_type.${replacement_sim_type}`
        ) || []
      );
    }
  );
